import { FunctionComponent, useEffect, useState } from 'react';
import { useAppInsightsContext } from '@microsoft/applicationinsights-react-js';
import { parseHtml } from '../Helper';
import { NextButton } from '../NextButton';
import languages from '../../Data/languages';
import { CheckboxRadioInput } from '../CheckboxRadioInput';
import type { LegacyResponse, Template } from '../../types';

interface OutroPageProps {
  template: Template;
  response: LegacyResponse;
  updateResponse: (key: string, value: unknown) => void;
  sendFinalResponse: (onSuccess?: () => void) => void;
  sending?: boolean;
}

export const OutroPage: FunctionComponent<OutroPageProps> = ({
  template,
  response,
  updateResponse,
  sendFinalResponse,
  sending
}) => {
  const [isConsentChangeSubmitted, setIsConsentChangeSubmitted] = useState(false);
  const language = template.language.name;
  const appInsights = useAppInsightsContext();
  useEffect(() => {
    appInsights.trackPageView({ name: 'OutroPage.tsx' });

    if (template.autoReload) {
      setTimeout(() => {
        globalThis.location.reload();
      }, 2000);
    }
  }, [appInsights, template.autoReload]);
  function getSubmitButtonText() {
    if (sending) {
      return languages.SUBMITTING[language];
    }
    if (isConsentChangeSubmitted) {
      return languages.SUBMITTED[language];
    }
    return languages.SUBMIT[language];
  }

  function setOutroText() {
    if (!template.includeCustomOutroText) {
      return template.outroText;
    }
    const rating = response.rating as number;
    if (rating <= 6) {
      return template.outroDetractorText;
    }
    if (rating === 7 || rating === 8) {
      return template.outroPassiveText;
    }
    if (rating > 8) {
      return template.outroPromoterText;
    }
  }
  return (
    <div className="body">
      <h2 className="text-center">{parseHtml(setOutroText())}</h2>
      {template.consentForPublicUse && template.consentForPublicUsePlacement === 2 && (
        <div>
          <CheckboxRadioInput
            type="checkbox"
            defaultChecked={response.allowedForPublicUse}
            name="allowedForPublicUseCheckbox"
            question={parseHtml(template.consentForPublicUseText)}
            onClick={() => {
              updateResponse('allowedForPublicUse', !response.allowedForPublicUse);
              setIsConsentChangeSubmitted(false);
            }}
          />
          <br />
          <div className="clearfix">
            <NextButton
              className="pull-right btn"
              onClick={() => {
                appInsights.trackEvent({
                  name: 'Commented',
                  properties: response
                });
                sendFinalResponse(() => setIsConsentChangeSubmitted(true));
              }}
              style={{ background: template.colorScheme }}
              disabled={sending || isConsentChangeSubmitted}
              loading={sending}
            >
              {getSubmitButtonText()}
            </NextButton>
          </div>
        </div>
      )}
    </div>
  );
};
